// @flow
import * as React from 'react';
import { get } from 'lodash';
import { Button, ThemeContext } from 'grommet';
import connectAPI from 'speed-js-react/src/api/connectAPI';
import ApiClient from 'speed-js-core/src/api/ApiClient';


type Props = {
    // eslint-disable-next-line react/no-unused-prop-types
    resourceName: string,
    // eslint-disable-next-line react/no-unused-prop-types
    resourceMethod: string,
    fileAccessor: string,
    row: Object,
    icon: React.Node,

    requestToken: Function,
};

const DownloadComponent = (props: Props) => {
    const {
        fileAccessor, row, icon, requestToken,
    } = props;

    const theme = {
        button: {
            border: {
                width: '2px',
                radius: '14px',
            },
            extend: () => `
                    padding: 8px;
                `,
        },
    };

    return (
        <ThemeContext.Extend
            value={theme}
        >
            <Button
                icon={icon}
                onClick={() => {
                    requestToken(get(row, fileAccessor)).then((res) => {
                        window.location.assign(`${get(row, fileAccessor)}/token=${res.token}`);
                    });
                }}
            />
        </ThemeContext.Extend>
    );
};

const apiCallback = (apiClient: ApiClient, props: Props) => ({
    requestToken: {
        send: (filename: string) => get(apiClient.resources, props.resourceName)[props.resourceMethod](filename),
    },
});

export default connectAPI(apiCallback)(DownloadComponent);
